<template>
  <div
    class="filters"
  >
    <button
      class="clear-filters-button margin secondary small uppercase"
      :class="{ invisible: !filterCount || !filterCount }"
      @click.prevent="$emit('clearFilter')"
    >
      Clear filters <span>({{ filterCount }})</span>
    </button>
    <div class="filters" v-if="filter">
      <filter-group :title="'Availability'" :is-custom="true" v-if="showStockFilter">
        <template v-slot:options>
          <Checkbox
            :modelValue="filter.inStock"
            @update:modelValue="updateFilter({ inStock: $event})"
            :title="'In Stock'"
            :circle="true"
            :disabled="!filter.inStock && (!stockCount || stockCount < 1)"
          />
        </template>
      </filter-group>
      <filter-group
        v-if="taxonomyCategories.length"
        :modelValue="filter['taxonomyCategories']"
        @update:modelValue="updateFilter({ taxonomyCategories: $event })"
        :options="taxonomyCategories"
        :title="'Product'"
        :expandCount="maxCheckboxes"
        :allow-expand="true"
      ></filter-group>
      <template v-for="attribute in taxonomyAttributes" :key="`taxonomy-attribute-${attribute.id}`">
        <filter-group
          :modelValue="filter['taxonomyAttributes']"
          @update:modelValue="updateFilter({ taxonomyAttributes: $event })"
          :options="attribute.attributes"
          :title="attribute.name"
          :expandCount="maxCheckboxes"
          :allow-expand="true"
          :allow-collapse="false"
        ></filter-group>
      </template>
      <filter-group v-if="showSaleFilter || showClearanceFilter" :title="'Sale'" :is-custom="true">
        <template v-slot:options>
          <Checkbox
            v-if="showSaleFilter"
            :modelValue="filter.onSale"
            @update:modelValue="updateFilter({ onSale: $event})"
            :title="'Current Sale'"
            :circle="true"
            :disabled="!filter.onSale && (!saleCount || saleCount < 1)"
          />
          <Checkbox
            v-if="showClearanceFilter"
            :modelValue="filter.onClearance"
            @update:modelValue="updateFilter({ onClearance: $event})"
            :title="'Clearance Sale'"
            :circle="true"
            :disabled="!filter.onClearance && (!clearanceCount || clearanceCount < 1)"
          />
        </template>
      </filter-group>
    </div>
  </div>
</template>
<script>
import { computed, ref, toRef } from 'vue';
import { Checkbox } from '@/pixel/index';
import FilterGroup from '@/components/browseNa/FilterGroup.vue';

// Maximum number of checkboxes to display before collapsing groups
const MAX_CHECKBOXES_BEFORE_COLLAPSE = 10;

export default {
  components: {
    FilterGroup,
    Checkbox
  },

  props: {
    filterCount: {
      type: Number,
      default: 0
    },
    filter: {
      type: Object,
      default: () => ({})
    },
    taxonomyCategories: {
      type: Array,
      default: () => ([])
    },
    taxonomyAttributes: {
      type: Array,
      default: () => ([])
    },
    showSaleFilter: {
      type: Boolean,
      default: true
    },
    showClearanceFilter: {
      type: Boolean,
      default: true
    },
    showStockFilter: {
      type: Boolean,
      default: true
    },
    saleCount: {
      type: Number,
      default: 0
    },
    clearanceCount: {
      type: Number,
      default: 0
    },
    stockCount: {
      type: Number,
      default: 0
    }
  },

  emits: ['update:filter', 'clearFilter'],

  setup(props, { emit }) {
    const filterRef = toRef(props, 'filter');

    function updateFilter(update = {}) {
      emit('update:filter', { ...filterRef.value, ...update });
    }

    return {
      maxCheckboxes: MAX_CHECKBOXES_BEFORE_COLLAPSE,
      updateFilter,
    };
  }
}
</script>
<style lang="postcss" scoped> 

</style>